export default __webpack_public_path__ + "static/media/icon_tracking.29844e6e.svg";